module.exports = __webpack_public_path__ + "img/business.8e36c0cc.png";